import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'extractFeedbackMessage',
  standalone: true,
})
export class ExtractFeedbackMessagePipe implements PipeTransform {
  transform(htmlString: string): unknown {
    const template = document.createElement('template')
    template.innerHTML = htmlString?.trim() || ''

    return template.content.querySelector('.message-feedback')?.innerHTML || ''
  }
}
